export class GlobalElement {
  public static permission: string = null;
}